import getFirebaseEnv from '../../configs/dbConfigs' 
import * as firebase from "firebase/app"
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/functions';


const config = getFirebaseEnv();

class Firebase {
  constructor() {
    //firebase.initializeApp(config);
  
    /* Helper */

    //this.serverValue = firebase.database.ServerValue;
    //this.emailAuthProvider = app.auth.EmailAuthProvider;

    /* Firebase APIs */

  /*  this.auth = firebase.auth();
    this.db = firebase.database();
    this.storage = firebase.storage();
    this.firestore = firebase.firestore();
    this.functions = firebase.functions();

    /* Social Sign In Method Provider */

    /*this.googleProvider = new firebase.auth.GoogleAuthProvider();
    this.facebookProvider = new firebase.auth.FacebookAuthProvider();
    this.twitterProvider = new firebase.auth.TwitterAuthProvider();*/
    
  }

  // *** Auth API ***

  /*doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithTwitter = () =>
    this.auth.signInWithPopup(this.twitterProvider);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
    });

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB User API *** //

  onAuthUserListener = (next, fallback) =>
    this.auth.onAuthStateChanged(authUser => {
      if (authUser) {
        this.user(authUser.uid)
          .once('value')
          .then(snapshot => {
            const dbUser = snapshot.val();
            // default empty roles
            if (!dbUser.roles) {
              dbUser.roles = {};
            }

            // merge auth and db user
            authUser = {
              uid: authUser.uid,
              email: authUser.email,
              emailVerified: authUser.emailVerified,
              providerData: authUser.providerData,
              ...dbUser,
            };

            next(authUser);
          });
      } else {
        fallback();
      }
    });

  // *** exposing database for req queries ***
  database = () => this.db;

  // *** User API ***

  user = uid => this.db.ref(`users/${uid}`);

  users = () => this.db.ref('users');

  // *** Customer API ***

  customer = uid => this.db.ref(`customers/${uid}`);

  customers = () => this.db.ref('customers');


  // *** Message API ***

  message = uid => this.db.ref(`messages/${uid}`);

  messages = () => this.db.ref('messages');

  // **** Document API ***
  document = uid => this.db.ref(`documents/${uid}`);

  documents = () => this.db.ref('documents');

  // *** Meeting API ***

  meeting = (uid, mid) => this.db.ref(`users/${uid}/meetings/${mid}`);

  meetings = (uid) => this.db.ref(`users/${uid}/meetings`);

  // *** siteSettings API ***/

  //settings = () => this.db.ref('settings');

  //***** Connection Ref Look at App.js for handler */
  //connectedRef = () =>  this.db.ref(".info/connected");
  
  // *** Storage Refs ***

  //storageRef = () => this.storage.ref('/');

  // **** sharecode API  *****

  //sharecode = (uid) => this.db.ref(`sharecodes/${uid}`);

  //Analytics Events
  //analytics = () => this.firestore.collection('analytics_0');
  /**
   * IMPORTANT: Slide events are aggregated per document-slide combination.
   * Individual events are meeting specific
   */
  /*sendSlideChangeEvent = (meeting, userId, duration) => {
    const slideNo = meeting.presentation.currentSlide -1;
    const docId = meeting.presentation.docId+"-"+slideNo;
    this.firestore.collection('analytics_0').doc(docId).set(
          {
            eventCategory: 'MEETING',
            event: 'SLIDE_CHANGE',
            title: meeting.title,
            documentId: meeting.presentation.docId,
            slideNo: slideNo,
            totalDuration: firebase.firestore.FieldValue.increment(duration)
          }
    );
    this.firestore.collection('analytics_0').doc(docId).collection('events').add(
      {
        ts: new Date().getTime(),
        meetingId: meeting.uid,
        slideNo: slideNo,
        userId: userId,
        duration: duration
      });
    }

  getAgoraToken = (channelName, uid) => {
    const method =  this.functions.httpsCallable('generateToken');
    return method({
        channelName: channelName,
        uid: uid
      });
      //return this.settings().once('value');
  }*/
}

export default Firebase;
